"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var initialState = null;

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, (0, _fluxActions.combineActions)(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, ActionTypes.MEETINGS_USER_FETCH_SUCCEEDED), function (state, action) {
  var meetingsUser = action.payload.meetingsUser;

  if (!meetingsUser) {
    return state;
  }

  return meetingsUser.calendarProvider;
}), initialState);

exports.default = _default;
module.exports = exports.default;